export default class ClassInfo {
  name: string
  begin: string
  end: string
  teacher: string
  constructor (displayName: string, begin: string, end: string, teacher: string) {
    this.name = displayName
    this.begin = begin
    this.end = end
    this.teacher = teacher
  }
}
